/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Seat_Change_Success_MemberInputs */



/**
* | output |
* | --- |
* | "Done – they now have a {type} seat." |
*
* @param {Seat_Change_Success_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_success_member = /** @type {((inputs: Seat_Change_Success_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Success_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Erledigt – das Mitglied hat jetzt einen ${i?.type}-Platz.`)
	return /** @type {LocalizedString} */ (`Done – they now have a ${i?.type} seat.`)
});